/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import * as tslib_1 from "tslib";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
export var API_BASE_URL_RENTASSISTANT = new InjectionToken('API_BASE_URL_RENTASSISTANT');
var RentAssistantClient = /** @class */ (function () {
    function RentAssistantClient(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44397";
    }
    RentAssistantClient.prototype.widget_SaveRealEstateObject = function (widgetParams) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Widget/saveRealEstateObject";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(widgetParams);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processWidget_SaveRealEstateObject(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processWidget_SaveRealEstateObject(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processWidget_SaveRealEstateObject = function (response) {
        var e_1, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.widget_GetWidgetProperty = function (realEstateObjectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Widget/getWidgetProperty?";
        if (realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' cannot be null.");
        else if (realEstateObjectId !== undefined)
            url_ += "realEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processWidget_GetWidgetProperty(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processWidget_GetWidgetProperty(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processWidget_GetWidgetProperty = function (response) {
        var e_2, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.widget_GetProfileScore = function (profile) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Widget/GetProfileScore";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(profile);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processWidget_GetProfileScore(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processWidget_GetProfileScore(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processWidget_GetProfileScore = function (response) {
        var e_3, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.widget_GetProfileScoreForAnonymousProperty = function (profile) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Widget/GetProfileScoreForAnonymousProperty";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(profile);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processWidget_GetProfileScoreForAnonymousProperty(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processWidget_GetProfileScoreForAnonymousProperty(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processWidget_GetProfileScoreForAnonymousProperty = function (response) {
        var e_4, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get a list of all Actions
     * @return A list of Action strings
     */
    RentAssistantClient.prototype.actions_Get = function () {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/actions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processActions_Get(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processActions_Get(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processActions_Get = function (response) {
        var e_5, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Get a list of all available actions on a candidacy.
     * @param id The id of the candidacy to get the actions for.
     */
    RentAssistantClient.prototype.actions_GetCandidacyActions = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/{id}/actions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processActions_GetCandidacyActions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processActions_GetCandidacyActions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processActions_GetCandidacyActions = function (response) {
        var e_6, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Performs an action on a candidacy.
     * @param id The id of the candidacy to take action on.
     * @param action Contains an action id and an optional comment.
     */
    RentAssistantClient.prototype.candidacies_CandidacyAction = function (id, action) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/{id}/actions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(action);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_CandidacyAction(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_CandidacyAction(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_CandidacyAction = function (response) {
        var e_7, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_7) throw e_7.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.actions_SendEmail = function (emailDto) {
        var _this = this;
        var url_ = this.baseUrl + "/actions/email";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(emailDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processActions_SendEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processActions_SendEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processActions_SendEmail = function (response) {
        var e_8, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_8) throw e_8.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Gets a broker by it's organization number.
     * @param organizationNumber Broker organization number
     */
    RentAssistantClient.prototype.brokers_Get = function (organizationNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/brokers/{organizationNumber}";
        if (organizationNumber === undefined || organizationNumber === null)
            throw new Error("The parameter 'organizationNumber' must be defined.");
        url_ = url_.replace("{organizationNumber}", encodeURIComponent("" + organizationNumber));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBrokers_Get(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBrokers_Get(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processBrokers_Get = function (response) {
        var e_9, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_9) throw e_9.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Get a candidacy by it's unique id.
     * @param id Candidacy id
     * @param includeProfile (optional) true, to include the full profile associated with the candidacy
     * @return A candidacy with it's profile details
     */
    RentAssistantClient.prototype.candidacies_GetCandidacy = function (id, includeProfile) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeProfile !== undefined && includeProfile !== null)
            url_ += "includeProfile=" + encodeURIComponent("" + includeProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_GetCandidacy(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_GetCandidacy(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_GetCandidacy = function (response) {
        var e_10, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_10) throw e_10.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.candidacies_GetCandidaciesForRealEstateObjectId = function (realEstateObjectId, status, searchTerm, candidacyOrderBy_SortOrder, candidacyOrderBy_CandidacyOrderByEnum) {
        var _this = this;
        var url_ = this.baseUrl + "/candidaciesForRealEstateObjectId?";
        if (realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' cannot be null.");
        else if (realEstateObjectId !== undefined)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (candidacyOrderBy_SortOrder === null)
            throw new Error("The parameter 'candidacyOrderBy_SortOrder' cannot be null.");
        else if (candidacyOrderBy_SortOrder !== undefined)
            url_ += "CandidacyOrderBy.SortOrder=" + encodeURIComponent("" + candidacyOrderBy_SortOrder) + "&";
        if (candidacyOrderBy_CandidacyOrderByEnum === null)
            throw new Error("The parameter 'candidacyOrderBy_CandidacyOrderByEnum' cannot be null.");
        else if (candidacyOrderBy_CandidacyOrderByEnum !== undefined)
            url_ += "CandidacyOrderBy.CandidacyOrderByEnum=" + encodeURIComponent("" + candidacyOrderBy_CandidacyOrderByEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_GetCandidaciesForRealEstateObjectId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_GetCandidaciesForRealEstateObjectId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_GetCandidaciesForRealEstateObjectId = function (response) {
        var e_11, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_11) throw e_11.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.candidacies_GetCandidaciesForRealEstateObjectIdPaged = function (realEstateObjectId, status, searchTerm, candidacyOrderBy_SortOrder, candidacyOrderBy_CandidacyOrderByEnum, index, size) {
        var _this = this;
        var url_ = this.baseUrl + "/candidaciesForRealEstateObjectIdPaged?";
        if (realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' cannot be null.");
        else if (realEstateObjectId !== undefined)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (candidacyOrderBy_SortOrder === null)
            throw new Error("The parameter 'candidacyOrderBy_SortOrder' cannot be null.");
        else if (candidacyOrderBy_SortOrder !== undefined)
            url_ += "CandidacyOrderBy.SortOrder=" + encodeURIComponent("" + candidacyOrderBy_SortOrder) + "&";
        if (candidacyOrderBy_CandidacyOrderByEnum === null)
            throw new Error("The parameter 'candidacyOrderBy_CandidacyOrderByEnum' cannot be null.");
        else if (candidacyOrderBy_CandidacyOrderByEnum !== undefined)
            url_ += "CandidacyOrderBy.CandidacyOrderByEnum=" + encodeURIComponent("" + candidacyOrderBy_CandidacyOrderByEnum) + "&";
        if (index === null)
            throw new Error("The parameter 'index' cannot be null.");
        else if (index !== undefined)
            url_ += "Index=" + encodeURIComponent("" + index) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_GetCandidaciesForRealEstateObjectIdPaged(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_GetCandidaciesForRealEstateObjectIdPaged(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_GetCandidaciesForRealEstateObjectIdPaged = function (response) {
        var e_12, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_12_1) { e_12 = { error: e_12_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_12) throw e_12.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.candidacies_GetUnreadCandidaciesCount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/unreadCandidaciesCount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_GetUnreadCandidaciesCount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_GetUnreadCandidaciesCount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_GetUnreadCandidaciesCount = function (response) {
        var e_13, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_13_1) { e_13 = { error: e_13_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_13) throw e_13.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.candidacies_GetUnreadCandidacies = function () {
        var _this = this;
        var url_ = this.baseUrl + "/unreadCandidacies";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_GetUnreadCandidacies(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_GetUnreadCandidacies(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_GetUnreadCandidacies = function (response) {
        var e_14, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_14_1) { e_14 = { error: e_14_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_14) throw e_14.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.candidacies_SetCandidacyRead = function (uniqueId) {
        var _this = this;
        var url_ = this.baseUrl + "/setCandidacyRead";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(uniqueId);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_SetCandidacyRead(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_SetCandidacyRead(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_SetCandidacyRead = function (response) {
        var e_15, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_15_1) { e_15 = { error: e_15_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_15) throw e_15.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.candidacies_CreateCandidacyInternalComment = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/createCandidacyInternalComment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_CreateCandidacyInternalComment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_CreateCandidacyInternalComment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_CreateCandidacyInternalComment = function (response) {
        var e_16, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_16_1) { e_16 = { error: e_16_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_16) throw e_16.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Get a paged list of all candidacies for a specific broker
     * @param realEstateObjectId (optional) The REDS id of the property
     * @param from (optional)
     * @param to (optional)
     * @param offset (optional) The offset used during paging
     * @param count (optional) The count used during paging
     * @return A paged result list of candidacies
     */
    RentAssistantClient.prototype.candidacies_GetCandidaciesForBroker = function (realEstateObjectId, from, to, offset, count) {
        var _this = this;
        var url_ = this.baseUrl + "/broker/candidacies?";
        if (realEstateObjectId !== undefined && realEstateObjectId !== null)
            url_ += "realEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_GetCandidaciesForBroker(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_GetCandidaciesForBroker(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_GetCandidaciesForBroker = function (response) {
        var e_17, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_17_1) { e_17 = { error: e_17_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_17) throw e_17.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Get a list of all candidacies of logged in user.
     * @return A list of CandidacyDto objects.
     */
    RentAssistantClient.prototype.candidacies_GetMyCandidacies = function () {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/me";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_GetMyCandidacies(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_GetMyCandidacies(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_GetMyCandidacies = function (response) {
        var e_18, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_18_1) { e_18 = { error: e_18_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_18) throw e_18.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Create a new candidacy for the logged in user.
     * @param newCandidacy Contains the broker's organization number and the property's reference id.
     * @return A Dto for the created Candidacy
     */
    RentAssistantClient.prototype.candidacies_CreateCandidacy = function (newCandidacy) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(newCandidacy);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_CreateCandidacy(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_CreateCandidacy(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_CreateCandidacy = function (response) {
        var e_19, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_19_1) { e_19 = { error: e_19_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_19) throw e_19.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.candidacies_UpdateBrokerComment = function (updateBrokerCommentDto) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/updateBrokerComment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(updateBrokerCommentDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_UpdateBrokerComment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_UpdateBrokerComment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_UpdateBrokerComment = function (response) {
        var e_20, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_20_1) { e_20 = { error: e_20_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_20) throw e_20.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.candidacies_RejectAllForRealEstateObjectId = function (rejectAllDto) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/rejectAllForRealEstateObjectId";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(rejectAllDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_RejectAllForRealEstateObjectId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_RejectAllForRealEstateObjectId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_RejectAllForRealEstateObjectId = function (response) {
        var e_21, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_21_1) { e_21 = { error: e_21_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_21) throw e_21.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.candidacies_ArchiveCandidacy = function (candidacyArchive) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/archive";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(candidacyArchive);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_ArchiveCandidacy(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_ArchiveCandidacy(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_ArchiveCandidacy = function (response) {
        var e_22, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_22_1) { e_22 = { error: e_22_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_22) throw e_22.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.candidacies_GetScoreForCandidacy = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/getResult/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCandidacies_GetScoreForCandidacy(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCandidacies_GetScoreForCandidacy(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processCandidacies_GetScoreForCandidacy = function (response) {
        var e_23, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_23_1) { e_23 = { error: e_23_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_23) throw e_23.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.content_GetQuestionsAndAnswers = function (contentItemLanguage) {
        var _this = this;
        var url_ = this.baseUrl + "/content/qa?";
        if (contentItemLanguage === null)
            throw new Error("The parameter 'contentItemLanguage' cannot be null.");
        else if (contentItemLanguage !== undefined)
            url_ += "contentItemLanguage=" + encodeURIComponent("" + contentItemLanguage) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processContent_GetQuestionsAndAnswers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processContent_GetQuestionsAndAnswers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processContent_GetQuestionsAndAnswers = function (response) {
        var e_24, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_24_1) { e_24 = { error: e_24_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_24) throw e_24.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.content_GetWebTexts = function (contentItemLanguage) {
        var _this = this;
        var url_ = this.baseUrl + "/content/webtexts?";
        if (contentItemLanguage === null)
            throw new Error("The parameter 'contentItemLanguage' cannot be null.");
        else if (contentItemLanguage !== undefined)
            url_ += "contentItemLanguage=" + encodeURIComponent("" + contentItemLanguage) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processContent_GetWebTexts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processContent_GetWebTexts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processContent_GetWebTexts = function (response) {
        var e_25, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_25_1) { e_25 = { error: e_25_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_25) throw e_25.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Get a list of all ErrorCodes
     * @return A list of ErrorCodeDtos.
     */
    RentAssistantClient.prototype.errors_Get = function () {
        var _this = this;
        var url_ = this.baseUrl + "/Errors";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processErrors_Get(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processErrors_Get(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processErrors_Get = function (response) {
        var e_26, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_26_1) { e_26 = { error: e_26_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_26) throw e_26.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Get an Organization by it's organization number.
     * @param organizationNumber (optional) The organization number as registered in the KBO.
     * @return An Organization with address and functions included
     */
    RentAssistantClient.prototype.organizations_Get = function (organizationNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/organizations?";
        if (organizationNumber !== undefined && organizationNumber !== null)
            url_ += "organizationNumber=" + encodeURIComponent("" + organizationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOrganizations_Get(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOrganizations_Get(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processOrganizations_Get = function (response) {
        var e_27, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_27_1) { e_27 = { error: e_27_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_27) throw e_27.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.owner_OwnerLogin = function (ownerLoginDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Owner/login";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(ownerLoginDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOwner_OwnerLogin(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOwner_OwnerLogin(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processOwner_OwnerLogin = function (response) {
        var e_28, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_28_1) { e_28 = { error: e_28_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_28) throw e_28.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.owner_GetOwnerShortlistDto = function (shortlistUniqueId, phoneNumber, token, ownerSessionId, loginStatus, sessionAvailableUntil) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Owner/shortlist?";
        if (shortlistUniqueId === null)
            throw new Error("The parameter 'shortlistUniqueId' cannot be null.");
        else if (shortlistUniqueId !== undefined)
            url_ += "ShortlistUniqueId=" + encodeURIComponent("" + shortlistUniqueId) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (ownerSessionId !== undefined && ownerSessionId !== null)
            url_ += "OwnerSessionId=" + encodeURIComponent("" + ownerSessionId) + "&";
        if (loginStatus !== undefined && loginStatus !== null)
            url_ += "LoginStatus=" + encodeURIComponent("" + loginStatus) + "&";
        if (sessionAvailableUntil !== undefined && sessionAvailableUntil !== null)
            url_ += "SessionAvailableUntil=" + encodeURIComponent(sessionAvailableUntil ? "" + sessionAvailableUntil.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOwner_GetOwnerShortlistDto(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOwner_GetOwnerShortlistDto(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processOwner_GetOwnerShortlistDto = function (response) {
        var e_29, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_29_1) { e_29 = { error: e_29_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_29) throw e_29.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.owner_SaveOwnerPreference = function (ownerSavePreferenceDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Owner/SavePreference";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(ownerSavePreferenceDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOwner_SaveOwnerPreference(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOwner_SaveOwnerPreference(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processOwner_SaveOwnerPreference = function (response) {
        var e_30, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_30_1) { e_30 = { error: e_30_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_30) throw e_30.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.owner_SubmitPreference = function (ownerSubmitPreferenceDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Owner/SubmitPreference";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(ownerSubmitPreferenceDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOwner_SubmitPreference(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOwner_SubmitPreference(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processOwner_SubmitPreference = function (response) {
        var e_31, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_31_1) { e_31 = { error: e_31_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_31) throw e_31.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.owner_GetShortlistsProperty = function (realEstateObjectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Owner/getShortlistsProperty/{realEstateObjectId}";
        if (realEstateObjectId === undefined || realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' must be defined.");
        url_ = url_.replace("{realEstateObjectId}", encodeURIComponent("" + realEstateObjectId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOwner_GetShortlistsProperty(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOwner_GetShortlistsProperty(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processOwner_GetShortlistsProperty = function (response) {
        var e_32, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_32_1) { e_32 = { error: e_32_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_32) throw e_32.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Add an attachment to the current user's draft profile
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @param originalFileName (optional) The original filename of the uploaded file
     * @param personId (optional) The person that receives the attachment
     * @param type (optional) The attachment type
     * @param profile (optional) The full profile
     * @return The updated profile, which now includes a reference to the document in the Oris document store
     */
    RentAssistantClient.prototype.profilesAttachments_AddUserProfileAttachment = function (contentType, contentDisposition, headers, length, name, fileName, originalFileName, personId, type, profile) {
        var _this = this;
        var url_ = this.baseUrl + "/profiles/latest/attachments?";
        if (originalFileName !== undefined && originalFileName !== null)
            url_ += "originalFileName=" + encodeURIComponent("" + originalFileName) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (profile !== undefined && profile !== null)
            url_ += "profile=" + encodeURIComponent("" + profile) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", headers.toString());
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfilesAttachments_AddUserProfileAttachment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfilesAttachments_AddUserProfileAttachment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfilesAttachments_AddUserProfileAttachment = function (response) {
        var e_33, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_33_1) { e_33 = { error: e_33_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_33) throw e_33.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Delete an attachment from the current user's draft profile
     * @param profile The full profile
     * @param documentId (optional) The document store document id
     * @param personId (optional) The person to delete the attachment for
     */
    RentAssistantClient.prototype.profilesAttachments_DeleteUserProfileAttachment = function (profile, documentId, personId) {
        var _this = this;
        var url_ = this.baseUrl + "/profiles/latest/attachments?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(profile);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfilesAttachments_DeleteUserProfileAttachment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfilesAttachments_DeleteUserProfileAttachment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfilesAttachments_DeleteUserProfileAttachment = function (response) {
        var e_34, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_34_1) { e_34 = { error: e_34_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_34) throw e_34.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Add an attachment to the candidacy profile
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @param originalFileName (optional) The original filename of the uploaded file
     * @param personId (optional) The person that receives the attachment
     * @param type (optional) The attachment type
     * @param profile (optional) The full profile
     * @return The updated profile, which now includes the id of the document in the Oris document store
     */
    RentAssistantClient.prototype.profilesAttachments_AddCandidacyProfileAttachment = function (candidacyId, contentType, contentDisposition, headers, length, name, fileName, originalFileName, personId, type, profile) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/{candidacyId}/profiles/attachments?";
        if (candidacyId === undefined || candidacyId === null)
            throw new Error("The parameter 'candidacyId' must be defined.");
        url_ = url_.replace("{candidacyId}", encodeURIComponent("" + candidacyId));
        if (originalFileName !== undefined && originalFileName !== null)
            url_ += "originalFileName=" + encodeURIComponent("" + originalFileName) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (profile !== undefined && profile !== null)
            url_ += "profile=" + encodeURIComponent("" + profile) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", headers.toString());
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfilesAttachments_AddCandidacyProfileAttachment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfilesAttachments_AddCandidacyProfileAttachment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfilesAttachments_AddCandidacyProfileAttachment = function (response) {
        var e_35, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_35_1) { e_35 = { error: e_35_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_35) throw e_35.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Delete an attachment from the candidacy profile
     * @param candidacyId The unique Id of the candidacy
     * @param profile The full profile
     * @param documentId (optional) The document store document id
     * @param personId (optional) The person to delete the attachment for
     */
    RentAssistantClient.prototype.profilesAttachments_DeleteCandidacyProfileAttachment = function (candidacyId, profile, documentId, personId) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/{candidacyId}/profiles/attachments?";
        if (candidacyId === undefined || candidacyId === null)
            throw new Error("The parameter 'candidacyId' must be defined.");
        url_ = url_.replace("{candidacyId}", encodeURIComponent("" + candidacyId));
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(profile);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfilesAttachments_DeleteCandidacyProfileAttachment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfilesAttachments_DeleteCandidacyProfileAttachment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfilesAttachments_DeleteCandidacyProfileAttachment = function (response) {
        var e_36, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_36_1) { e_36 = { error: e_36_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_36) throw e_36.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Download an attachment from the document store
     * @param documentId The document store document id
     * @return A stream containing the requested file
     */
    RentAssistantClient.prototype.profilesAttachments_Download = function (documentId) {
        var _this = this;
        var url_ = this.baseUrl + "/attachments/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfilesAttachments_Download(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfilesAttachments_Download(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfilesAttachments_Download = function (response) {
        var e_37, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_37_1) { e_37 = { error: e_37_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_37) throw e_37.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Download an attachment from the document store
     * @param documentId The document store document id
     * @return A stream containing the requested file
     */
    RentAssistantClient.prototype.profilesAttachments_DownloadBase64 = function (documentId) {
        var _this = this;
        var url_ = this.baseUrl + "/attachments/base64/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfilesAttachments_DownloadBase64(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfilesAttachments_DownloadBase64(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfilesAttachments_DownloadBase64 = function (response) {
        var e_38, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_38_1) { e_38 = { error: e_38_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_38) throw e_38.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Get the latest profile for the current user
     * @return Profile details with completeness indication
     */
    RentAssistantClient.prototype.profiles_GetUserProfile = function () {
        var _this = this;
        var url_ = this.baseUrl + "/profiles/latest";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfiles_GetUserProfile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfiles_GetUserProfile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfiles_GetUserProfile = function (response) {
        var e_39, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_39_1) { e_39 = { error: e_39_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_39) throw e_39.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.profiles_GetUserProfileByFilter = function (searchTerm, realEstateObjectId, pageIndex, pageSize) {
        var _this = this;
        var url_ = this.baseUrl + "/profiles/filter?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (realEstateObjectId !== undefined && realEstateObjectId !== null)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfiles_GetUserProfileByFilter(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfiles_GetUserProfileByFilter(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfiles_GetUserProfileByFilter = function (response) {
        var e_40, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_40_1) { e_40 = { error: e_40_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_40) throw e_40.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Get the latest profile for the specified candidacy
     * @param candidacyId The id of the candidacy
     * @return Profile details with completeness indication
     */
    RentAssistantClient.prototype.profiles_GetCandidacyProfile = function (candidacyId) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/{candidacyId}/profiles/latest";
        if (candidacyId === undefined || candidacyId === null)
            throw new Error("The parameter 'candidacyId' must be defined.");
        url_ = url_.replace("{candidacyId}", encodeURIComponent("" + candidacyId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfiles_GetCandidacyProfile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfiles_GetCandidacyProfile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfiles_GetCandidacyProfile = function (response) {
        var e_41, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_41_1) { e_41 = { error: e_41_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_41) throw e_41.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Save a user's draft profile
     * @param profileDetailsDto The profile details
     * @return Profile details with completeness indication
     */
    RentAssistantClient.prototype.profiles_SaveUserProfile = function (profileDetailsDto) {
        var _this = this;
        var url_ = this.baseUrl + "/profiles";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(profileDetailsDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfiles_SaveUserProfile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfiles_SaveUserProfile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfiles_SaveUserProfile = function (response) {
        var e_42, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_42_1) { e_42 = { error: e_42_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_42) throw e_42.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Save a profile for the specified candidacy
     * @param candidacyId The unique ID of the candidacy
     * @param profileDetailsDto The profile details
     * @return Profile details with completeness indication
     */
    RentAssistantClient.prototype.profiles_SaveCandidacyProfile = function (candidacyId, profileDetailsDto) {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/{candidacyId}/profiles";
        if (candidacyId === undefined || candidacyId === null)
            throw new Error("The parameter 'candidacyId' must be defined.");
        url_ = url_.replace("{candidacyId}", encodeURIComponent("" + candidacyId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(profileDetailsDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfiles_SaveCandidacyProfile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfiles_SaveCandidacyProfile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfiles_SaveCandidacyProfile = function (response) {
        var e_43, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_43_1) { e_43 = { error: e_43_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_43) throw e_43.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Generates a public token for a profile. This can be a user (draft) profile or a candidacy profile.
     * @param candidacyId (optional) Optional unique id in the case of a candidacy profile
     * @return A public token that can be used to fetch a readonly version of the profile
     */
    RentAssistantClient.prototype.profiles_GetPublicToken = function (candidacyId) {
        var _this = this;
        var url_ = this.baseUrl + "/profiles/latest/token?";
        if (candidacyId !== undefined && candidacyId !== null)
            url_ += "candidacyId=" + encodeURIComponent("" + candidacyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfiles_GetPublicToken(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfiles_GetPublicToken(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfiles_GetPublicToken = function (response) {
        var e_44, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_44_1) { e_44 = { error: e_44_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_44) throw e_44.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.profiles_ShareLatestProfile = function (shareProfileDto) {
        var _this = this;
        var url_ = this.baseUrl + "/profiles/shareLatestProfile";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(shareProfileDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProfiles_ShareLatestProfile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProfiles_ShareLatestProfile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProfiles_ShareLatestProfile = function (response) {
        var e_45, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_45_1) { e_45 = { error: e_45_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_45) throw e_45.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Gets a property by it's reference.
     * @param realEstateObjectId Uniquely identifies a property
     */
    RentAssistantClient.prototype.properties_Get = function (realEstateObjectId) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/{realEstateObjectId}";
        if (realEstateObjectId === undefined || realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' must be defined.");
        url_ = url_.replace("{realEstateObjectId}", encodeURIComponent("" + realEstateObjectId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_Get(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_Get(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_Get = function (response) {
        var e_46, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_46_1) { e_46 = { error: e_46_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_46) throw e_46.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Gets a properties by it's filter.
     * @param searchTerm (optional)
     * @param sortOrder (optional)
     * @param propertiesOrderBy (optional)
     * @param onlyPropertiesWithCandidacies (optional)
     * @param hasExternalLink (optional)
     * @param status (optional)
     * @param pageIndex (optional)
     * @param pageSize (optional)
     */
    RentAssistantClient.prototype.properties_GetByFilter = function (searchTerm, sortOrder, propertiesOrderBy, onlyPropertiesWithCandidacies, hasExternalLink, status, pageIndex, pageSize) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/filter?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (propertiesOrderBy !== undefined && propertiesOrderBy !== null)
            url_ += "PropertiesOrderBy=" + encodeURIComponent("" + propertiesOrderBy) + "&";
        if (onlyPropertiesWithCandidacies !== undefined && onlyPropertiesWithCandidacies !== null)
            url_ += "OnlyPropertiesWithCandidacies=" + encodeURIComponent("" + onlyPropertiesWithCandidacies) + "&";
        if (hasExternalLink !== undefined && hasExternalLink !== null)
            url_ += "HasExternalLink=" + encodeURIComponent("" + hasExternalLink) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(function (item) { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_GetByFilter(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_GetByFilter(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_GetByFilter = function (response) {
        var e_47, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_47_1) { e_47 = { error: e_47_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_47) throw e_47.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.properties_GetCandidacyInvitations = function (realEstateObjectId, searchTerm, sortOrder, orderBy, onlyPropertiesWithCandidacies, pageIndex, pageSize) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/candidacyInvitations?";
        if (realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' cannot be null.");
        else if (realEstateObjectId !== undefined)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (onlyPropertiesWithCandidacies !== undefined && onlyPropertiesWithCandidacies !== null)
            url_ += "OnlyPropertiesWithCandidacies=" + encodeURIComponent("" + onlyPropertiesWithCandidacies) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_GetCandidacyInvitations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_GetCandidacyInvitations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_GetCandidacyInvitations = function (response) {
        var e_48, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_48_1) { e_48 = { error: e_48_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_48) throw e_48.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.properties_GetFullLogForProperty = function (realEstateObjectId, periodFrom, periodTo, userId, logType, logOrderBy, orderByDescending, pageIndex, pageSize) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/getFullLog?";
        if (realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' cannot be null.");
        else if (realEstateObjectId !== undefined)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (periodFrom !== undefined && periodFrom !== null)
            url_ += "PeriodFrom=" + encodeURIComponent(periodFrom ? "" + periodFrom.toJSON() : "") + "&";
        if (periodTo !== undefined && periodTo !== null)
            url_ += "PeriodTo=" + encodeURIComponent(periodTo ? "" + periodTo.toJSON() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (logType !== undefined && logType !== null)
            url_ += "LogType=" + encodeURIComponent("" + logType) + "&";
        if (logOrderBy !== undefined && logOrderBy !== null)
            url_ += "LogOrderBy=" + encodeURIComponent("" + logOrderBy) + "&";
        if (orderByDescending !== undefined && orderByDescending !== null)
            url_ += "OrderByDescending=" + encodeURIComponent("" + orderByDescending) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_GetFullLogForProperty(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_GetFullLogForProperty(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_GetFullLogForProperty = function (response) {
        var e_49, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_49_1) { e_49 = { error: e_49_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_49) throw e_49.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.properties_LinkRealEstateObjectToRealSmartId = function (realEstateObjectRealSmartLink) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/CreateRealSmartLink";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(realEstateObjectRealSmartLink);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_LinkRealEstateObjectToRealSmartId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_LinkRealEstateObjectToRealSmartId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_LinkRealEstateObjectToRealSmartId = function (response) {
        var e_50, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_50_1) { e_50 = { error: e_50_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_50) throw e_50.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.properties_UpdateStatus = function (propertyStatusUpdateDto) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(propertyStatusUpdateDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_UpdateStatus(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_UpdateStatus(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_UpdateStatus = function (response) {
        var e_51, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_51_1) { e_51 = { error: e_51_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_51) throw e_51.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.properties_CreateProperty = function (manualPropertyDto) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(manualPropertyDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_CreateProperty(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_CreateProperty(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_CreateProperty = function (response) {
        var e_52, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_52_1) { e_52 = { error: e_52_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_52) throw e_52.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.properties_RemoveRealSmartLink = function (realEstateObjectIds) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/RemoveRealSmartLink";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(realEstateObjectIds);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_RemoveRealSmartLink(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_RemoveRealSmartLink(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_RemoveRealSmartLink = function (response) {
        var e_53, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_53_1) { e_53 = { error: e_53_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_53) throw e_53.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.properties_TransferProperty = function (propertyTransfer) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/transfer";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(propertyTransfer);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_TransferProperty(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_TransferProperty(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_TransferProperty = function (response) {
        var e_54, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_54_1) { e_54 = { error: e_54_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_54) throw e_54.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.properties_RemoveTransfer = function (realEsateObjectId) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/removeTransfer";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(realEsateObjectId);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_RemoveTransfer(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_RemoveTransfer(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_RemoveTransfer = function (response) {
        var e_55, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_55_1) { e_55 = { error: e_55_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_55) throw e_55.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.properties_InviteForCandidacy = function (inviteForCandidacyDto) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/inviteCandidacy";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(inviteForCandidacyDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_InviteForCandidacy(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_InviteForCandidacy(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_InviteForCandidacy = function (response) {
        var e_56, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_56_1) { e_56 = { error: e_56_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_56) throw e_56.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.properties_UpdateProperty = function (propertyRealSmartUpdateDto) {
        var _this = this;
        var url_ = this.baseUrl + "/properties/update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(propertyRealSmartUpdateDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processProperties_UpdateProperty(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processProperties_UpdateProperty(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processProperties_UpdateProperty = function (response) {
        var e_57, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_57_1) { e_57 = { error: e_57_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_57) throw e_57.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    RentAssistantClient.prototype.shortlist_CreateShortlist = function (createShortlistDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shortlist/createShortlist";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(createShortlistDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processShortlist_CreateShortlist(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processShortlist_CreateShortlist(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processShortlist_CreateShortlist = function (response) {
        var e_58, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_58_1) { e_58 = { error: e_58_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_58) throw e_58.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.shortlist_GetShortlistByRealEstateId = function (realEstateObjectId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shortlist/getShortlistsByRealEstateObjectId/{realEstateObjectId}";
        if (realEstateObjectId === undefined || realEstateObjectId === null)
            throw new Error("The parameter 'realEstateObjectId' must be defined.");
        url_ = url_.replace("{realEstateObjectId}", encodeURIComponent("" + realEstateObjectId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processShortlist_GetShortlistByRealEstateId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processShortlist_GetShortlistByRealEstateId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processShortlist_GetShortlistByRealEstateId = function (response) {
        var e_59, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_59_1) { e_59 = { error: e_59_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_59) throw e_59.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.shortlist_CancelShortlist = function (shortlistUniqueId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shortlist/cancelShortlist/{shortlistUniqueId}";
        if (shortlistUniqueId === undefined || shortlistUniqueId === null)
            throw new Error("The parameter 'shortlistUniqueId' must be defined.");
        url_ = url_.replace("{shortlistUniqueId}", encodeURIComponent("" + shortlistUniqueId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processShortlist_CancelShortlist(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processShortlist_CancelShortlist(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processShortlist_CancelShortlist = function (response) {
        var e_60, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_60_1) { e_60 = { error: e_60_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_60) throw e_60.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.shortlist_ExtendShortlist = function (extendShortlistDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Shortlist/extendShortlist";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(extendShortlistDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processShortlist_ExtendShortlist(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processShortlist_ExtendShortlist(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processShortlist_ExtendShortlist = function (response) {
        var e_61, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_61_1) { e_61 = { error: e_61_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_61) throw e_61.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Get a list of all candidacy  statuses
     * @return A list of Status strings.
     */
    RentAssistantClient.prototype.statuses_Get = function () {
        var _this = this;
        var url_ = this.baseUrl + "/candidacies/statuses";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processStatuses_Get(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processStatuses_Get(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processStatuses_Get = function (response) {
        var e_62, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_62_1) { e_62 = { error: e_62_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_62) throw e_62.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Get the profile corresponding to the given public token
     * @param token A token that matches a single profile
     * @return Profile details with metadata
     */
    RentAssistantClient.prototype.tokens_GetProfileByToken = function (token) {
        var _this = this;
        var url_ = this.baseUrl + "/tokens/{token}/profile";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processTokens_GetProfileByToken(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processTokens_GetProfileByToken(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processTokens_GetProfileByToken = function (response) {
        var e_63, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_63_1) { e_63 = { error: e_63_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_63) throw e_63.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Returns the user details of the current logged in user.
     * @return Returns the logged in user details.
     */
    RentAssistantClient.prototype.users_GetMe = function () {
        var _this = this;
        var url_ = this.baseUrl + "/Users/me";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUsers_GetMe(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUsers_GetMe(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processUsers_GetMe = function (response) {
        var e_64, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_64_1) { e_64 = { error: e_64_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_64) throw e_64.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    /**
     * Creates or updates the current logged in user in the database.
     * @param updateUser PrivacyStatementAccepted: Boolean to define if the user has accepted the privacy statement.
     * @return Returns the created or updated User details.
     */
    RentAssistantClient.prototype.users_CreateOrUpdateUser = function (updateUser) {
        var _this = this;
        var url_ = this.baseUrl + "/Users/me";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(updateUser);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUsers_CreateOrUpdateUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUsers_CreateOrUpdateUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processUsers_CreateOrUpdateUser = function (response) {
        var e_65, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_65_1) { e_65 = { error: e_65_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_65) throw e_65.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.users_DeleteUser = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUsers_DeleteUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUsers_DeleteUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processUsers_DeleteUser = function (response) {
        var e_66, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_66_1) { e_66 = { error: e_66_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_66) throw e_66.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.users_GetUserProfileByFilter = function (searchTerm, realEstateObjectId, pageIndex, pageSize) {
        var _this = this;
        var url_ = this.baseUrl + "/Users/filter?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (realEstateObjectId !== undefined && realEstateObjectId !== null)
            url_ += "RealEstateObjectId=" + encodeURIComponent("" + realEstateObjectId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUsers_GetUserProfileByFilter(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUsers_GetUserProfileByFilter(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processUsers_GetUserProfileByFilter = function (response) {
        var e_67, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_67_1) { e_67 = { error: e_67_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_67) throw e_67.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.whitelistings_SaveWhitelisting = function (domains) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Whitelistings/saveWhitelisting";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(domains);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processWhitelistings_SaveWhitelisting(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processWhitelistings_SaveWhitelisting(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processWhitelistings_SaveWhitelisting = function (response) {
        var e_68, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_68_1) { e_68 = { error: e_68_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_68) throw e_68.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    RentAssistantClient.prototype.whitelistings_GetWhitelistingForBroker = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Whitelistings/whitelisting";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processWhitelistings_GetWhitelistingForBroker(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processWhitelistings_GetWhitelistingForBroker(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RentAssistantClient.prototype.processWhitelistings_GetWhitelistingForBroker = function (response) {
        var e_69, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = tslib_1.__values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_69_1) { e_69 = { error: e_69_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_69) throw e_69.error; }
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        }
        else {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultdefault = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    };
    return RentAssistantClient;
}());
export { RentAssistantClient };
export var PropertyType;
(function (PropertyType) {
    PropertyType["House"] = "House";
    PropertyType["Apartment"] = "Apartment";
    PropertyType["Studio"] = "Studio";
})(PropertyType || (PropertyType = {}));
export var PropertyStatusDto;
(function (PropertyStatusDto) {
    PropertyStatusDto["Active"] = "Active";
    PropertyStatusDto["Archived"] = "Archived";
})(PropertyStatusDto || (PropertyStatusDto = {}));
export var Action;
(function (Action) {
    Action["Progress"] = "Progress";
    Action["Recall"] = "Recall";
    Action["Reject"] = "Reject";
    Action["Approve"] = "Approve";
    Action["Submit"] = "Submit";
    Action["RequestInfo"] = "RequestInfo";
    Action["Delete"] = "Delete";
    Action["ContactBroker"] = "ContactBroker";
})(Action || (Action = {}));
export var Status;
(function (Status) {
    Status["Draft"] = "Draft";
    Status["InProgress"] = "InProgress";
    Status["Recalled"] = "Recalled";
    Status["Rejected"] = "Rejected";
    Status["Approved"] = "Approved";
    Status["Submitted"] = "Submitted";
    Status["InfoRequested"] = "InfoRequested";
    Status["Expired"] = "Expired";
})(Status || (Status = {}));
export var Language;
(function (Language) {
    Language["Dutch"] = "Dutch";
    Language["English"] = "English";
    Language["French"] = "French";
    Language["German"] = "German";
})(Language || (Language = {}));
export var RelocationType;
(function (RelocationType) {
    RelocationType["NoPreference"] = "NoPreference";
    RelocationType["SpecificDate"] = "SpecificDate";
    RelocationType["Asap"] = "Asap";
})(RelocationType || (RelocationType = {}));
export var DurationType;
(function (DurationType) {
    DurationType["Max1Year"] = "Max1Year";
    DurationType["Max3Years"] = "Max3Years";
    DurationType["MoreThan3Years"] = "MoreThan3Years";
    DurationType["Specific"] = "Specific";
})(DurationType || (DurationType = {}));
export var PersonLegalType;
(function (PersonLegalType) {
    PersonLegalType["Person"] = "Person";
    PersonLegalType["LegalEntity"] = "LegalEntity";
})(PersonLegalType || (PersonLegalType = {}));
export var OtherIncomeType;
(function (OtherIncomeType) {
    OtherIncomeType["MealVouchers"] = "MealVouchers";
    OtherIncomeType["ChildrensAllowance"] = "ChildrensAllowance";
    OtherIncomeType["Alimony"] = "Alimony";
    OtherIncomeType["Interest"] = "Interest";
    OtherIncomeType["RentalPremium"] = "RentalPremium";
    OtherIncomeType["Other"] = "Other";
})(OtherIncomeType || (OtherIncomeType = {}));
export var AttachmentType;
(function (AttachmentType) {
    AttachmentType["ProofOfIncome"] = "ProofOfIncome";
    AttachmentType["CompanyPublication"] = "CompanyPublication";
    AttachmentType["BalanceSheet"] = "BalanceSheet";
    AttachmentType["ProofOfOtherIncome"] = "ProofOfOtherIncome";
    AttachmentType["Identification"] = "Identification";
    AttachmentType["ProofOfPaymentOfRent"] = "ProofOfPaymentOfRent";
})(AttachmentType || (AttachmentType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Desc"] = "Desc";
    SortOrder["Asc"] = "Asc";
})(SortOrder || (SortOrder = {}));
export var CandidacyOrderByEnum;
(function (CandidacyOrderByEnum) {
    CandidacyOrderByEnum["FirstName"] = "FirstName";
    CandidacyOrderByEnum["LastName"] = "LastName";
    CandidacyOrderByEnum["Email"] = "Email";
    CandidacyOrderByEnum["Status"] = "Status";
    CandidacyOrderByEnum["Date"] = "Date";
    CandidacyOrderByEnum["Domicile"] = "Domicile";
    CandidacyOrderByEnum["ProffesionalUse"] = "ProffesionalUse";
})(CandidacyOrderByEnum || (CandidacyOrderByEnum = {}));
export var QaCategory;
(function (QaCategory) {
    QaCategory["AanmeldenRegistreren"] = "AanmeldenRegistreren";
    QaCategory["Gebruik"] = "Gebruik";
    QaCategory["Algemeen"] = "Algemeen";
    QaCategory["Verhuurproces"] = "Verhuurproces";
    QaCategory["Tips"] = "Tips";
    QaCategory["Advies"] = "Advies";
    QaCategory["Makelaar"] = "Makelaar";
    QaCategory["Eigenaar"] = "Eigenaar";
})(QaCategory || (QaCategory = {}));
export var ContentItemStatus;
(function (ContentItemStatus) {
    ContentItemStatus["Active"] = "Active";
    ContentItemStatus["Concept"] = "Concept";
    ContentItemStatus["Archived"] = "Archived";
    ContentItemStatus["Deleted"] = "Deleted";
})(ContentItemStatus || (ContentItemStatus = {}));
export var ContentItemLanguage;
(function (ContentItemLanguage) {
    ContentItemLanguage["Nl"] = "Nl";
    ContentItemLanguage["Fr"] = "Fr";
    ContentItemLanguage["De"] = "De";
    ContentItemLanguage["En"] = "En";
})(ContentItemLanguage || (ContentItemLanguage = {}));
export var LoginStatus;
(function (LoginStatus) {
    LoginStatus["Unknown"] = "Unknown";
    LoginStatus["TokenSend"] = "TokenSend";
    LoginStatus["SessionCreated"] = "SessionCreated";
    LoginStatus["SessionExpired"] = "SessionExpired";
    LoginStatus["Unauthorized"] = "Unauthorized";
    LoginStatus["InvalidToken"] = "InvalidToken";
    LoginStatus["AlreadySubmitted"] = "AlreadySubmitted";
    LoginStatus["ShortlistExpired"] = "ShortlistExpired";
})(LoginStatus || (LoginStatus = {}));
export var PropertiesOrderBy;
(function (PropertiesOrderBy) {
    PropertiesOrderBy["Address"] = "Address";
    PropertiesOrderBy["RealSmartLink"] = "RealSmartLink";
    PropertiesOrderBy["CandidaciesCount"] = "CandidaciesCount";
    PropertiesOrderBy["LastActivity"] = "LastActivity";
    PropertiesOrderBy["Status"] = "Status";
})(PropertiesOrderBy || (PropertiesOrderBy = {}));
export var CandidacyInvitationOrderBy;
(function (CandidacyInvitationOrderBy) {
    CandidacyInvitationOrderBy["Email"] = "Email";
    CandidacyInvitationOrderBy["Date"] = "Date";
})(CandidacyInvitationOrderBy || (CandidacyInvitationOrderBy = {}));
export var LogType;
(function (LogType) {
    LogType["CandidacyStatusChange"] = "CandidacyStatusChange";
    LogType["RealSmartLinkChange"] = "RealSmartLinkChange";
    LogType["ShortListChange"] = "ShortListChange";
    LogType["PropertyTransferChange"] = "PropertyTransferChange";
})(LogType || (LogType = {}));
export var LogOrderBy;
(function (LogOrderBy) {
    LogOrderBy["Date"] = "Date";
    LogOrderBy["LogType"] = "LogType";
    LogOrderBy["UserId"] = "UserId";
})(LogOrderBy || (LogOrderBy = {}));
export var ManualPropertyTypeEnum;
(function (ManualPropertyTypeEnum) {
    ManualPropertyTypeEnum["House"] = "House";
    ManualPropertyTypeEnum["Apartment"] = "Apartment";
    ManualPropertyTypeEnum["Studio"] = "Studio";
})(ManualPropertyTypeEnum || (ManualPropertyTypeEnum = {}));
export var ShortListStatus;
(function (ShortListStatus) {
    ShortListStatus["Draft"] = "Draft";
    ShortListStatus["InProgress"] = "InProgress";
    ShortListStatus["Submitted"] = "Submitted";
    ShortListStatus["Expired"] = "Expired";
    ShortListStatus["Created"] = "Created";
    ShortListStatus["Cancelled"] = "Cancelled";
})(ShortListStatus || (ShortListStatus = {}));
var ApiException = /** @class */ (function (_super) {
    tslib_1.__extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
export { ApiException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new Observable(function (observer) {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            var reader = new FileReader();
            reader.onload = function (event) {
                observer.next(event.target.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
